import Select from 'react-select';
import {getReactSelectDefaultProps} from 'config/react-select';
import React, {useEffect, useMemo, useState} from 'react';
import _ from 'lodash';
import {forceRefreshSessionInfo} from 'module/SessionInfo/api/SessionInfoAPI';
import {switchMandantHandler} from 'module/SessionInfo/api/SwitchMandantAPI';

function getMandantDisplayText(mandant) {
	if (mandant.isDefault) return getDefaultMandantDisplayText(mandant);
	if (mandant.text != null) {
		return mandant.id + " - " + mandant.text;
	} else {
		return mandant.id;
	}
}


function getDefaultMandantDisplayText(mandant) {
	if (mandant.text != null) {
		return mandant.id + " - " + mandant.text + " (Default)";
	} else {
		return mandant.id + " (Default)";
	}
}

export const MandantSelect = ({mandant: savedMandant, defaultMandant, alternativeMandants = []}) => {
	const [mandant, setMandant] = useState(savedMandant);
	const defaultMandantId = defaultMandant && defaultMandant.id || null;
	//override saved and current mandant id with null when equal to default mandant id (null represents default)
	let savedMandantId = savedMandant && savedMandant.id || null;
	if (savedMandantId === defaultMandantId) savedMandantId = null;
	let mandantId = mandant && mandant.id || null;
	if (mandantId === defaultMandantId) mandantId = null;
	const ds = useMemo(() => alternativeMandants.concat({
		...defaultMandant,
		isDefault: true,
	}), [alternativeMandants, defaultMandant]);
	useEffect(() => {
		const t = setTimeout(() => {
			if (!_.isEqual(mandantId, savedMandantId)) {
				switchMandantHandler(mandantId).then(() => forceRefreshSessionInfo())
			}
		}, 1500);
		return () => clearTimeout(t);
	}, [savedMandantId, mandantId]);
	return (
		<Select {...getReactSelectDefaultProps({
			isClearable: true,
			isDisabled: ds.length < 2,
			options: ds,
			value: mandant,
			getOptionValue: x => x,
			getOptionLabel: getMandantDisplayText,
			onChange: (value) => setMandant(value),
		})}/>
	);
};